import { useToastContext } from "../../../../../../../common/components/ui/toast/toast.context";
import ButtonWithLoader from "../../../../../../../common/components/ui/loading/ButtonLoading";
import { updateVehicleVisualRecords } from "../../../../../../../common/services/vehicles.api";
import SlideToggle from "../../../../../../../common/components/ui/toggleSwitch/SlideToggle";
import { DateSubscriptionFormik } from "../../../../forms/fields/DateSubscriptionFormik";
import { numberToCurrency } from "../../../../../../../common/helpers/currency.helpers";
import ComboBoxFormik from "../../../../../../../common/components/form/ComboBoxFormik";
import { finishedSubscription } from "../../../../../../../common/services/renters.api";
import TextAreaFormik from "../../../../../../../common/components/form/TextAreaFormik";
import { FormikProvider, getIn, useFormik, useFormikContext } from "formik";
import { IRenter } from "../../../../../../../types/renter.type";
import { useMemo, useState } from "react";
import RegisterPhotos from "./field/RegisterPhotos";
import DynamicFields from "./field/DynamicFields";
import * as Yup from 'yup';
import { InstallmentOption, useCalculateInstallmentOptions } from "../../../../../helpers/calculationUtils";
import AditionalValuesCancelPlan from "./field/AdditionalValuesCancelPlan";

const validationSchema = Yup.object().shape({
  // Seus outros campos...
  additionalComments: Yup.string().required('Comentarios adicionais é obrigatório'),
});

type Props = {
  data: IRenter
  vehicleId: string
  daysRemaining: number
}


export default function FinishedPlanModal(props: Props) {
  const [isChecked, setIsChecked] = useState(false);
  const { notifySuccess, notifyError } = useToastContext()
  const renter = props.data;
  const vehicleId = props.vehicleId;
  const firstInstallmentDate = renter.activationData?.plan?.subscriptionInitialDate;
  const caucao = renter.activationData.plan?.deposit;
  const formikContext = useFormikContext()
  const registers = getIn(formikContext.values, 'registers')
  const renterId = getIn(formikContext.values, 'renterId')
  const nameRenter = getIn(formikContext.values, 'renterName')
  const vehicle = getIn(formikContext.values, 'vehicle')
  const returnReason = getIn(formikContext.values, 'returnReason')
  const licensePlate = getIn(formikContext.values, "licensePlate");


  const onAddRegister = () => {
    formikContext.setFieldValue('registers', [...registers, { type: '', content: '', verified: false }])
  }

  const valueWeeks = renter.activationData.plan?.value || 0;
  const dailyValue = parseFloat(renter?.activationData?.plan?.price?.replace('R$', '').replace(',', '.') || "0");
  const finePlanValue = 0;

  const paymentOptions = [
    { value: "-", label: "-" },
    { value: "PIX", label: "PIX( Para Pagamento na hora)" },
    { value: "CREDIT_CARD", label: "CRÉDITO (Conferir no Asaas)" },
    { value: "BOLETO", label: "BOLETO" },
  ];

  const formik = useFormik({

    initialValues: {
      fields: [], // Inicializa com um campo vazio
      reason: "",
      caucao: caucao,
      totalFines: 0,
      sinister: 0,
      dailyValue: dailyValue,
      valueWeeks: valueWeeks,
      billingPeriod: "",
      paymentMethod: "",
      installmentOption: "",
      paymentOptions: paymentOptions,
      isCheckedCommandBlock: false,
      isPostWeekChecked: false,
      additionalComments: "",
      paymentDescription: "",
      subscriptionInitialDate: firstInstallmentDate,
      valueTotalBoolean: false,
      finalFineValue: 0, // Campo para receber o valor total calculado
      amountValue: 0,
      isCheckedRetraction: false,
      installmentValue: "",
      // Outras inicializações...
    },
    validationSchema: validationSchema,
    onSubmit: async (data) => {

      const receivedData = {
        renterId: renterId,
        fineDetran: data.fields,  // Garanta que isso é um array de objetos com 'value' e 'description'
        additionalComments: data.additionalComments,
        paymentDescription: data.paymentDescription,
        valueBlockCommand: data.isCheckedCommandBlock,
        vehicleId: vehicleId,
        customerId: renter.externalReferences.paymentCustomerId,
        paymentMethod: data.paymentMethod,
        installmentOptions: data.installmentOption,
        isCheckedRetraction: data.isCheckedRetraction,
        sinister: data.sinister,
        billingPeriod: data.billingPeriod,
        subscriptionInitialDate: data.subscriptionInitialDate,
        caucao: caucao?.toString(),  // Converta para string se não for
        finalFineValue: data.totalFines,
        valueTotal: valueTotal,  // Converte para número se necessário
        installmentValue: data.installmentValue,
        amountValue: data.amountValue,
        valueBilling: Math.max(0, data.finalFineValue - (caucao || 0)),
      };

      const result = await finishedSubscription(receivedData)
      if (!result.ok) {
        notifyError("Erro ao cancelar o contrato");
      }
      notifySuccess("Contrato cancelado com sucesso");

      const savePhotoDelivery = {
        renterId: renterId,
        vehicleId: vehicle._id,
        photos: registers,
        nameRenter: nameRenter,
        licensePlate: licensePlate,
        returnReason: returnReason,
      }

      const resultPhoto = await updateVehicleVisualRecords(savePhotoDelivery)
      if (!resultPhoto.ok) {
        notifyError(resultPhoto.message as string)
        return
      }
      notifySuccess("Fotos salvas com sucesso");


    }
  })

  // Calcula a soma total das multas
  const valueFineAddition = formik.values.amountValue;
  const valueTotal = caucao - formik.values.finalFineValue;

  const calculateInstallmentOptions = useCalculateInstallmentOptions();
  const installmentOptions: InstallmentOption[] = useMemo(() => {
    return calculateInstallmentOptions((valueTotal - caucao), 24);
  }, [valueTotal, caucao, calculateInstallmentOptions]);

  // Callback para receber o total calculado do componente de valores adicionais
  const handleTotalChange = ({ initalValue, amountValue, isCheckedRetraction, isCheckedCommandBlock, valuesSinister, isPostWeekChecked }:
    {
      initalValue: number;
      amountValue: number;
      isCheckedRetraction: boolean;
      isCheckedCommandBlock: boolean;
      valuesSinister: number;
      isPostWeekChecked: boolean;

    }) => {
    formik.setFieldValue('finalFineValue', initalValue);
    formik.setFieldValue('amountValue', amountValue);
    formik.setFieldValue('isCheckedRetraction', isCheckedRetraction);
    formik.setFieldValue('isCheckedCommandBlock', isCheckedCommandBlock);
    formik.setFieldValue('sinister', valuesSinister);
    formik.setFieldValue('isPostWeekChecked', isPostWeekChecked);
    // Se necessário, você pode atualizar outro campo com o amountValue
    // formik.setFieldValue('amountValue', amountValue);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <section>
          <div className="pb-4 mt-4">
            <label className="font-semibold text-sm">O valor do caução do cliente é de:</label>
            <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
              {numberToCurrency(caucao)}
            </p>
          </div>
        </section>

        <section>
          <AditionalValuesCancelPlan
            onTotalChange={handleTotalChange}
            valueWeeks={valueWeeks}
            dailyFine={dailyValue}
            finePlanValue={finePlanValue.toString()}
          />

        </section>

        <div className="pb-3 mt-2" style={{ display: 'flex', alignItems: 'center' }}>
          <label className="font-semibold text-[14px]"> O cliente tem multas de transito? </label>
          <SlideToggle
            name="isChecked"
            className="ml-2"
            onToggle={(checked) => {
              setIsChecked(checked);
              formik.setFieldValue("isChecked", checked);
            }}
          />          <span style={{ marginLeft: '10px' }}>{isChecked ? "Sim" : "Não"}</span>
        </div>

        <div>
          {isChecked && <DynamicFields />}
        </div>
        <div className="pb-6 mt-2 flex flex-col gap-2">
          <TextAreaFormik
            name="additionalComments"
            label="Cometários sobre a finalização do plano:"
            placeholder="Insira seus comentários aqui..."
          />
        </div>
        <section>
          <div className="pb-4 mt-8">
            <label className="font-semibold text-sm">Valor total das taxas:</label>
            <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
              {numberToCurrency(valueFineAddition)}
            </p>
          </div>
          {formik.values.totalFines > 0 &&
            <div className="pb-4">
              <label className="font-semibold text-sm">Valor total das multas de transito:</label>
              <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
                {numberToCurrency(formik.values.totalFines)}
              </p>
            </div>
          }
          {caucao > valueFineAddition && valueTotal > 0 &&
            <div className="pb-4">
              <label className="font-semibold text-sm">Valor total a ser devolvido:</label>
              <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
                {numberToCurrency(valueTotal)}
              </p>
            </div>
          }
          {valueFineAddition > caucao && valueTotal < 0 &&
            <div>
              <p className="font-semibold text-sm">Valor que será cobrado:</p>
              <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
                {numberToCurrency(Math.abs(valueTotal))}
              </p>
              <p className="text-redPrimary text-sm">O valor total das multas é maior que o valor do caução</p>

              {valueTotal < 0 && (
                <div>
                  <ComboBoxFormik
                    name="paymentMethod"
                    label="Escolha o método de pagamento:"
                    options={paymentOptions}
                    required={true}
                  />

                  {(formik.values.paymentMethod === 'CREDIT_CARD' || formik.values.paymentMethod === 'BOLETO') && (
                    <section>
                      <ComboBoxFormik
                        name="installmentOption"
                        label="Escolha a opção de parcelamento:"
                        options={installmentOptions}
                        required={true}
                      />

                      <ComboBoxFormik
                        name="billingPeriod"
                        label="Escolha o período da cobrança"
                        options={[
                          { value: "", label: "-" },
                          { value: "mensal", label: "Mensal" },
                          { value: "semanal", label: "Semanal" },
                        ]}
                        required={true}
                      />
                      <DateSubscriptionFormik />
                    </section>
                  )}

                  <div className="flex flex-col gap-2">
                    <label htmlFor="paymentDescription" className="block text-sm font-medium text-gray-600">
                      Descrição do pagamento
                    </label>
                    <textarea
                      id="paymentDescription"
                      name="paymentDescription"
                      value={formik.values.paymentDescription}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      style={{ resize: "none", height: "90px" }}
                    />
                    {formik.touched.paymentDescription && formik.errors.paymentDescription && (
                      <div className="text-redPrimary text-sm">{formik.errors.paymentDescription}</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          }
        </section>
      </FormikProvider>
      <RegisterPhotos
        title={"Inspeção de Veículo"}  // Usar um título padrão caso não seja fornecido
        items={registers}
        vehicleId={vehicleId}  // Garantindo que o ID do veículo esteja sempre disponível
        renterId={renter._id!}
        nameRenter={nameRenter}
        onAddItem={onAddRegister}  // Método para adicionar um registro
        updateStatus={undefined}  // Se você tiver uma função para atualizar o status, passe aqui
        titleTextArea={'Descreva as avarias da moto:'}
      />
      <div className="flex justify-end mt-4">
        <ButtonWithLoader
          type="button" isLoading={formik.isSubmitting} disabled={!formik.isValid} onClick={formik.handleSubmit}          >
          Finalizar Plano
        </ButtonWithLoader>
      </div>
    </form >
  )
}